import react from 'react';
import { SplashRecordContext } from '../components/contextProviders/SplashRecord';
const { useContext } = react;

export default function useSplashRecord() {
    return useContext(SplashRecordContext);
}
